import * as React from "react"
import { batch } from '@preact/signals-react'
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate, getPreviousDate } from "@ui-seeker/utils"

import { SkuInfoBlock } from "@components"
import { DATE_PERIODS, GROUPED_BY } from "@constants"
import { commonFiltersValue } from "@signals"
import { marketAnalyzerEvolutionSkuFilters, marketAnalyzerSkuDetailsFilters, marketAnalyzerEvolutionSkuCurrentPeriod, marketAnalyzerEndDate } from "../../../@signals"


export default function skuColumn() {
	return [{
        name: 'category', label: 'Category',
        options: {
            display: 'excluded'
        }
    }, {
        name: 'brand', label: 'Brand',
        options: {
            display: 'excluded'
        }
    }, {
		name:'ean', label: 'EAN',
		options: {
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
		name: 'sku', label: 'Product Name',
		options: {
			headerAlign: 'left',
            filterType: 'textField',
			customBodyRowRenderLite: (value, { category, brand, ean, sku, skuID, country, reference }) => <>
                <SkuInfoBlock
                    sku={value}
                    category={category}
                    brand={brand}
                    ean={ean}
                    reference={reference}
                />
                <ShowSkuEvolution skuID={skuID} country={country}/>
                <ShowSkuDetails skuID={skuID} sku={sku} country={country} />
			</>
		}
	}]
}

const ShowSkuEvolution = ({skuID, country}) => {
    const newFilters = commonFiltersValue.peek()

    const handleClickEvolution = () => { batch(() => {
        marketAnalyzerEndDate.value = newFilters.endDate
        let startDate = formatDate(getPreviousDate({days: 6}, marketAnalyzerEndDate.value), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

        marketAnalyzerEvolutionSkuCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS

        marketAnalyzerEvolutionSkuFilters.value = {
            ...commonFiltersValue.peek(),
            startDate: startDate,
            endDate: marketAnalyzerEndDate.value,
            sku: [skuID],
            country: [country]
        }
    })}

    return <Box data-tour-trigger sx={{ display: 'flex', alignItems: 'flex-end', mb: 1}} onClick={handleClickEvolution} >
        <Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover":{ fontWeight: 'bold' } }}>
            Show Price Evolution
        </Typography>
        <IconSeeker icon={'chart-line'} sx={{ mr: 0.5, margin: .5, color: 'primary.main'}}/>
    </Box>

}

const ShowSkuDetails = ({skuID, sku, country}) => {
    const handleClickDetails = () => { batch(() => {
        marketAnalyzerSkuDetailsFilters.value = {
            ...commonFiltersValue.peek(),
            sku: [skuID],
            country: [country],
            skuName: sku,
            splitKpi: GROUPED_BY.SKU
        }
    })}

    return <Box sx={{ display: 'flex', alignItems: 'flex-end'}} onClick={handleClickDetails} >
        <Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover":{ fontWeight: 'bold' } }}>
            Show daily details
        </Typography>
        <IconSeeker icon={'magnifying-glass'} sx={{ mr: 0.5, margin: .5, color: 'primary.main'}}/>
    </Box>

}